import { EditorProps } from '@tiptap/pm/view';

import { stripHtmlTags } from './editor/extensions/utils';

export const defaultEditorProps: EditorProps = {
  attributes: {
    class: `font-default focus:outline-none max-w-full [data-node-view-wrapper]:inline`,
  },
  handleDOMEvents: {
    keydown: (_view, event) => {
      // prevent default event listeners from firing when slash command is active
      if (['ArrowUp', 'ArrowDown', 'Enter'].includes(event.key)) {
        const slashCommand = document.querySelector('#slash-command');
        if (slashCommand) {
          return true;
        }
      }
    },
  },
  // Add paste handler to clean HTML spans during paste
  handlePaste: (view, event) => {
    if (event.clipboardData && event.clipboardData.getData('text/html')) {
      const html = event.clipboardData.getData('text/html');

      // Clean the HTML by removing spans
      const cleanedHtml = stripHtmlTags(html);

      // If HTML content was changed, we need to handle the paste ourselves
      if (cleanedHtml !== html) {
        const newClipboardData = new DataTransfer();

        // Add the cleaned HTML content
        newClipboardData.setData('text/html', cleanedHtml);

        // Add the plain text content
        const plainText = event.clipboardData.getData('text/plain');
        newClipboardData.setData('text/plain', plainText);

        // Create a new paste event with cleaned data
        const newEvent = new ClipboardEvent('paste', {
          clipboardData: newClipboardData,
          bubbles: true,
          cancelable: true,
        });

        // Prevent default paste to avoid double paste
        event.preventDefault();

        // Dispatch new paste event with cleaned content
        view.dom.dispatchEvent(newEvent);

        return true;
      }
    }

    // Let TipTap handle the paste event normally
    return false;
  },
};
